// src/config/permissionsConfig.js
/**
 * نظام الصلاحيات - Frontend Configuration
 * نسخة من نظام الصلاحيات من Backend للاستخدام في الواجهة
 */

// تعريف جميع الصلاحيات (يجب أن تتطابق مع Backend)
export const PERMISSIONS = {
  // القضايا
  CASES_VIEW_ALL: 'cases:view:all',
  CASES_VIEW_OWN: 'cases:view:own',
  CASES_CREATE: 'cases:create',
  CASES_EDIT_ALL: 'cases:edit:all',
  CASES_EDIT_OWN: 'cases:edit:own',
  CASES_DELETE_ALL: 'cases:delete:all',
  CASES_DELETE_OWN: 'cases:delete:own',

  // العملاء
  CLIENTS_VIEW_ALL: 'clients:view:all',
  CLIENTS_VIEW_OWN: 'clients:view:own',
  CLIENTS_CREATE: 'clients:create',
  CLIENTS_EDIT_ALL: 'clients:edit:all',
  CLIENTS_EDIT_OWN: 'clients:edit:own',
  CLIENTS_DELETE: 'clients:delete',

  // الجلسات
  SESSIONS_VIEW_ALL: 'sessions:view:all',
  SESSIONS_VIEW_OWN: 'sessions:view:own',
  SESSIONS_CREATE: 'sessions:create',
  SESSIONS_EDIT_ALL: 'sessions:edit:all',
  SESSIONS_EDIT_OWN: 'sessions:edit:own',
  SESSIONS_DELETE_ALL: 'sessions:delete:all',
  SESSIONS_DELETE_OWN: 'sessions:delete:own',

  // المستندات
  DOCUMENTS_VIEW: 'documents:view',
  DOCUMENTS_UPLOAD: 'documents:upload',
  DOCUMENTS_DELETE: 'documents:delete',
  DOCUMENTS_SHARE: 'documents:share',

  // المدفوعات
  PAYMENTS_VIEW_ALL: 'payments:view:all',
  PAYMENTS_VIEW_OWN: 'payments:view:own',
  PAYMENTS_CREATE: 'payments:create',
  PAYMENTS_EDIT_ALL: 'payments:edit:all',
  PAYMENTS_EDIT_OWN: 'payments:edit:own',
  PAYMENTS_DELETE_ALL: 'payments:delete:all',
  PAYMENTS_DELETE_OWN: 'payments:delete:own',

  // المصروفات
  EXPENSES_VIEW: 'expenses:view',
  EXPENSES_CREATE: 'expenses:create',
  EXPENSES_EDIT: 'expenses:edit',
  EXPENSES_APPROVE: 'expenses:approve',
  EXPENSES_DELETE: 'expenses:delete',

  // المستخدمين
  USERS_VIEW: 'users:view',
  USERS_CREATE: 'users:create',
  USERS_EDIT: 'users:edit',
  USERS_DELETE: 'users:delete',
  USERS_MANAGE_PERMISSIONS: 'users:manage:permissions',

  // الخصوم
  OPPONENTS_VIEW: 'opponents:view',
  OPPONENTS_CREATE: 'opponents:create',
  OPPONENTS_EDIT: 'opponents:edit',
  OPPONENTS_DELETE: 'opponents:delete',

  // الاستشارات
  CONSULTATIONS_VIEW: 'consultations:view',
  CONSULTATIONS_CREATE: 'consultations:create',
  CONSULTATIONS_EDIT: 'consultations:edit',
  CONSULTATIONS_DELETE: 'consultations:delete',

  // العقود
  CONTRACTS_VIEW: 'contracts:view',
  CONTRACTS_CREATE: 'contracts:create',
  CONTRACTS_EDIT: 'contracts:edit',
  CONTRACTS_DELETE: 'contracts:delete',

  // التنفيذات
  EXECUTIONS_VIEW: 'executions:view',
  EXECUTIONS_CREATE: 'executions:create',
  EXECUTIONS_EDIT: 'executions:edit',
  EXECUTIONS_DELETE: 'executions:delete',

  // النظام
  SETTINGS_VIEW: 'settings:view',
  SETTINGS_EDIT: 'settings:edit',
  REPORTS_VIEW: 'reports:view',
  REPORTS_GENERATE: 'reports:generate',
  DASHBOARD_VIEW: 'dashboard:view',
  NOTIFICATIONS_MANAGE: 'notifications:manage',
};

// أسماء الصلاحيات بالعربية للعرض في الواجهة
export const PERMISSION_LABELS = {
  // القضايا
  'cases:view:all': 'عرض جميع القضايا',
  'cases:view:own': 'عرض القضايا الخاصة',
  'cases:create': 'إنشاء قضية',
  'cases:edit:all': 'تعديل جميع القضايا',
  'cases:edit:own': 'تعديل القضايا الخاصة',
  'cases:delete:all': 'حذف جميع القضايا',
  'cases:delete:own': 'حذف القضايا الخاصة',

  // العملاء
  'clients:view:all': 'عرض جميع العملاء',
  'clients:view:own': 'عرض العملاء الخاصة',
  'clients:create': 'إنشاء عميل',
  'clients:edit:all': 'تعديل جميع العملاء',
  'clients:edit:own': 'تعديل العملاء الخاصة',
  'clients:delete': 'حذف العملاء',

  // الجلسات
  'sessions:view:all': 'عرض جميع الجلسات',
  'sessions:view:own': 'عرض الجلسات الخاصة',
  'sessions:create': 'إنشاء جلسة',
  'sessions:edit:all': 'تعديل جميع الجلسات',
  'sessions:edit:own': 'تعديل الجلسات الخاصة',
  'sessions:delete:all': 'حذف جميع الجلسات',
  'sessions:delete:own': 'حذف الجلسات الخاصة',

  // المستندات
  'documents:view': 'عرض المستندات',
  'documents:upload': 'رفع المستندات',
  'documents:delete': 'حذف المستندات',
  'documents:share': 'مشاركة المستندات',

  // المدفوعات
  'payments:view:all': 'عرض جميع المدفوعات',
  'payments:view:own': 'عرض المدفوعات الخاصة',
  'payments:create': 'إنشاء مدفوع',
  'payments:edit:all': 'تعديل جميع المدفوعات',
  'payments:edit:own': 'تعديل المدفوعات الخاصة',
  'payments:delete:all': 'حذف جميع المدفوعات',
  'payments:delete:own': 'حذف المدفوعات الخاصة',

  // المصروفات
  'expenses:view': 'عرض المصروفات',
  'expenses:create': 'إنشاء مصروف',
  'expenses:edit': 'تعديل المصروفات',
  'expenses:approve': 'الموافقة على المصروفات',
  'expenses:delete': 'حذف المصروفات',

  // المستخدمين
  'users:view': 'عرض المستخدمين',
  'users:create': 'إنشاء مستخدم',
  'users:edit': 'تعديل المستخدمين',
  'users:delete': 'حذف المستخدمين',
  'users:manage:permissions': 'إدارة الصلاحيات',

  // الخصوم
  'opponents:view': 'عرض الخصوم',
  'opponents:create': 'إنشاء خصم',
  'opponents:edit': 'تعديل الخصوم',
  'opponents:delete': 'حذف الخصوم',

  // الاستشارات
  'consultations:view': 'عرض الاستشارات',
  'consultations:create': 'إنشاء استشارة',
  'consultations:edit': 'تعديل الاستشارات',
  'consultations:delete': 'حذف الاستشارات',

  // العقود
  'contracts:view': 'عرض العقود',
  'contracts:create': 'إنشاء عقد',
  'contracts:edit': 'تعديل العقود',
  'contracts:delete': 'حذف العقود',

  // التنفيذات
  'executions:view': 'عرض التنفيذات',
  'executions:create': 'إنشاء تنفيذ',
  'executions:edit': 'تعديل التنفيذات',
  'executions:delete': 'حذف التنفيذات',

  // النظام
  'settings:view': 'عرض الإعدادات',
  'settings:edit': 'تعديل الإعدادات',
  'reports:view': 'عرض التقارير',
  'reports:generate': 'إنشاء التقارير',
  'dashboard:view': 'عرض لوحة التحكم',
  'notifications:manage': 'إدارة الإشعارات',
};

// تصنيفات الصلاحيات للعرض المنظم في الواجهة
export const PERMISSION_CATEGORIES = {
  cases: {
    name: 'القضايا',
    icon: 'FileText',
    permissions: [
      PERMISSIONS.CASES_VIEW_ALL,
      PERMISSIONS.CASES_VIEW_OWN,
      PERMISSIONS.CASES_CREATE,
      PERMISSIONS.CASES_EDIT_ALL,
      PERMISSIONS.CASES_EDIT_OWN,
      PERMISSIONS.CASES_DELETE_ALL,
      PERMISSIONS.CASES_DELETE_OWN,
    ],
  },
  clients: {
    name: 'العملاء',
    icon: 'Users',
    permissions: [
      PERMISSIONS.CLIENTS_VIEW_ALL,
      PERMISSIONS.CLIENTS_VIEW_OWN,
      PERMISSIONS.CLIENTS_CREATE,
      PERMISSIONS.CLIENTS_EDIT_ALL,
      PERMISSIONS.CLIENTS_EDIT_OWN,
      PERMISSIONS.CLIENTS_DELETE,
    ],
  },
  sessions: {
    name: 'الجلسات',
    icon: 'Calendar',
    permissions: [
      PERMISSIONS.SESSIONS_VIEW_ALL,
      PERMISSIONS.SESSIONS_VIEW_OWN,
      PERMISSIONS.SESSIONS_CREATE,
      PERMISSIONS.SESSIONS_EDIT_ALL,
      PERMISSIONS.SESSIONS_EDIT_OWN,
      PERMISSIONS.SESSIONS_DELETE_ALL,
      PERMISSIONS.SESSIONS_DELETE_OWN,
    ],
  },
  documents: {
    name: 'المستندات',
    icon: 'File',
    permissions: [
      PERMISSIONS.DOCUMENTS_VIEW,
      PERMISSIONS.DOCUMENTS_UPLOAD,
      PERMISSIONS.DOCUMENTS_DELETE,
      PERMISSIONS.DOCUMENTS_SHARE,
    ],
  },
  payments: {
    name: 'المدفوعات',
    icon: 'DollarSign',
    permissions: [
      PERMISSIONS.PAYMENTS_VIEW_ALL,
      PERMISSIONS.PAYMENTS_VIEW_OWN,
      PERMISSIONS.PAYMENTS_CREATE,
      PERMISSIONS.PAYMENTS_EDIT_ALL,
      PERMISSIONS.PAYMENTS_EDIT_OWN,
      PERMISSIONS.PAYMENTS_DELETE_ALL,
      PERMISSIONS.PAYMENTS_DELETE_OWN,
    ],
  },
  expenses: {
    name: 'المصروفات',
    icon: 'TrendingDown',
    permissions: [
      PERMISSIONS.EXPENSES_VIEW,
      PERMISSIONS.EXPENSES_CREATE,
      PERMISSIONS.EXPENSES_EDIT,
      PERMISSIONS.EXPENSES_APPROVE,
      PERMISSIONS.EXPENSES_DELETE,
    ],
  },
  users: {
    name: 'المستخدمين',
    icon: 'UserCog',
    permissions: [
      PERMISSIONS.USERS_VIEW,
      PERMISSIONS.USERS_CREATE,
      PERMISSIONS.USERS_EDIT,
      PERMISSIONS.USERS_DELETE,
      PERMISSIONS.USERS_MANAGE_PERMISSIONS,
    ],
  },
  opponents: {
    name: 'الخصوم',
    icon: 'UserX',
    permissions: [
      PERMISSIONS.OPPONENTS_VIEW,
      PERMISSIONS.OPPONENTS_CREATE,
      PERMISSIONS.OPPONENTS_EDIT,
      PERMISSIONS.OPPONENTS_DELETE,
    ],
  },
  consultations: {
    name: 'الاستشارات',
    icon: 'MessageSquare',
    permissions: [
      PERMISSIONS.CONSULTATIONS_VIEW,
      PERMISSIONS.CONSULTATIONS_CREATE,
      PERMISSIONS.CONSULTATIONS_EDIT,
      PERMISSIONS.CONSULTATIONS_DELETE,
    ],
  },
  contracts: {
    name: 'العقود',
    icon: 'FileSignature',
    permissions: [
      PERMISSIONS.CONTRACTS_VIEW,
      PERMISSIONS.CONTRACTS_CREATE,
      PERMISSIONS.CONTRACTS_EDIT,
      PERMISSIONS.CONTRACTS_DELETE,
    ],
  },
  executions: {
    name: 'التنفيذات',
    icon: 'Gavel',
    permissions: [
      PERMISSIONS.EXECUTIONS_VIEW,
      PERMISSIONS.EXECUTIONS_CREATE,
      PERMISSIONS.EXECUTIONS_EDIT,
      PERMISSIONS.EXECUTIONS_DELETE,
    ],
  },
  system: {
    name: 'النظام',
    icon: 'Settings',
    permissions: [
      PERMISSIONS.SETTINGS_VIEW,
      PERMISSIONS.SETTINGS_EDIT,
      PERMISSIONS.REPORTS_VIEW,
      PERMISSIONS.REPORTS_GENERATE,
      PERMISSIONS.DASHBOARD_VIEW,
      PERMISSIONS.NOTIFICATIONS_MANAGE,
    ],
  },
};
